import { Component } from '@angular/core';

@Component({
  templateUrl: './manage-subscriber.component.html',
  styleUrls: ['./manage-subscriber.component.scss']
})
export class ManageSubscriberComponent {
}
